import React from "react";

export default function ComingSoon({ title }) {
  return (
    <div className="bg-white dark:bg-[#1F2A3B] p-10 rounded-xl shadow-md transition-colors duration-300">
      <h3 className="text-xl font-bold mb-2">{title}</h3>
      <div className="text-gray-600 dark:text-gray-300">
        준비중(Coming soon)
      </div>
    </div>
  );
}